import { useRuleHealth } from '@/api/hooks/useDashboards';
import { RuleHealthPanel } from '@/components/dashboards/RuleHealthPanel';
import DetectiveChips from '@/components/ai/DetectiveChips';

/**
 * /app/rule-health — per-rule fires/week over a trailing 12-week window,
 * dormancy flag, estimated analyst-hours burned, and suppression share.
 * Backed by `GET /api/v1/dashboards/rule-health` (Plan 5 / Task 3); every
 * tile folds those four signals into one `story` sentence per rule.
 */
export default function RuleHealth(): JSX.Element {
  const { data, isLoading, error } = useRuleHealth();

  return (
    <div className="flex h-full flex-col gap-4">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">Rule Health</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Which fraud rules are firing, going dormant, or getting suppressed —
          trailing 12 weeks.
        </p>
      </div>

      <DetectiveChips module="rule-health" />

      <RuleHealthPanel
        kpis={data?.kpis}
        isLoading={isLoading}
        error={(error as Error) ?? null}
        emptyMessage="No rule fires recorded in the trailing 12 weeks."
      />
    </div>
  );
}
